module.exports = __webpack_public_path__ + "img/Protractor-05.7f2b1973.png";